const bylFormHelpers = require('./formErrors');
const bylForms = require('../components/forms');
const shippingHelpers = require('./shipping');
const billingHelpers = require('./billing');

const {
  forEachElement,
} = require('../common/utils/dom');

const comunasSelectSelector = 'select[name$="comunaCode"]';
const statesSelectSelector = 'select[name$="stateCode"]';
const countrySelectSelector = 'select[name$="country"]';
const citySelector = 'select[name$="city"]';

/**
 * Change the value of the field if it exists and activate the corresponding events.
 * @param {HTMLElement} field - field to set value
 * @param {string} value - value to set
 * @returns {boolean} false if the field does not exist
 */
function setFieldValue(field, value) {
  if (!field) return false;
  // eslint-disable-next-line no-param-reassign
  field.value = value;
  // if it is type select we launch change event
  const isTypeSelect = field?.tagName?.toLowerCase() === 'select';
  if (isTypeSelect) {
    field.dispatchEvent((new Event('change', { cancelable: true })));
  }
  return true;
}

/**
 * if you have dependent fields set the corresponding value
 * @param {HTMLElement} field - field it depends on
 */
function changeDependantField(field) {
  if (!field?.dataset?.dependant) return;
  const dependantField = document.getElementById(field.dataset.dependant);
  const dependantFieldValue = dependantField?.dataset?.newValue;
  if (!!dependantField && dependantFieldValue) {
    setFieldValue(dependantField, dependantFieldValue);
    delete dependantField.dataset.newValue;
  }
}

/**
 * change field values based on the attrs object parameter
 * @param {Object} attrs - object values to set with key being the form input name and value the input value
 * P.E.: {
 *  "dwfrm_shipping_shippingAddress_addressFields_firstName":"P",
 *  "dwfrm_shipping_shippingAddress_addressFields_lastName":"Sherman",
 *  "dwfrm_shipping_shippingAddress_addressFields_address1":"42 Wallaby Str",
 *  "dwfrm_shipping_shippingAddress_addressFields_city":"Sidney"
 *  ...
 * }
 * @param {HTMLElement} form - form to use
 */
function changeFormAddressValuesByObject(attrs, form) {
  if (!attrs || !form) return;
  let field;
  Object.keys(attrs).forEach((attr) => {
    const isCountryCode = attr === 'countryCode';
    const isStateCode = attr === 'stateCode';
    const element = isCountryCode ? 'country' : attr;
    let newValue = attrs[attr];
    field = form.querySelector(`[name$=${element}]`);
    const valueChange = isCountryCode || isStateCode
      ? (field?.options?.length > 2) // If length is 2 or less means there is a unique option (empty option + unique option)
      : !!field; // if the field does not exist it does not change the value
    if (element === 'phone') {
      const phoneArray = newValue.split(' ');
      const phoneBody = phoneArray.length === 2 ? phoneArray[1] : phoneArray[0];
      newValue = phoneBody;
      // change phonePrefix
      const phonePrefix = phoneArray.length === 2 ? phoneArray[0] : null;
      const phonePrefixSelector = form.querySelector('[name=phonePrefix]');
      if (!!phonePrefixSelector && phonePrefix) {
        setFieldValue(phonePrefixSelector, phonePrefix);
      }
    }
    if (valueChange) {
      setFieldValue(field, newValue);
      // saves value temporarily if dependent
      if (field?.dataset?.dependsOn) field.dataset.newValue = newValue;
      changeDependantField(field);
    }
  });
  // if it is the last element remove the temporary value
  if (field?.dataset?.newValue) delete field.dataset.newValue;
}

module.exports = {
  methods: {
    changeFormAddressValuesByObject,
  },
  addNewAddress() {
    $('.btn-add-new').off('click').on('click', function handleAddNewClick() {
      const $el = $(this);
      const $form = $el.parents('form');
      bylFormHelpers.clearPreviousErrors($form);

      if ($el.parents('#dwfrm_billing').length > 0) {
        billingHelpers.methods.selectNewAddress($form);
      } else {
        shippingHelpers.methods.selectNewAddress($form);
      }
    });
  },
  editAddress() {
    const editAddressButtonElements = document.querySelectorAll('.btn-edit-address');
    forEachElement(editAddressButtonElements, (buttonElement) => {
      // eslint-disable-next-line listeners/no-missing-remove-event-listener, listeners/no-inline-function-event-listener
      buttonElement.addEventListener('click', (event) => {
        const inputAddressToEdit = event.target.parentNode.querySelector('input[type=radio]');
        inputAddressToEdit.checked = true;
        $(inputAddressToEdit).trigger('change');

        const formElement = event.target.closest('form');
        formElement.dataset.editSavedAddress = true;

        if (formElement.classList.contains('payment-form')) {
          billingHelpers.methods.showOnlyBillingAddressBlock($(formElement));
        } else {
          shippingHelpers.methods.showOnlyAddressBlock($(formElement));
        }
      });
    });
  },

  associateCitySelect() {
    const cityField = document.querySelector(citySelector);
    if (!cityField) return;
    const isComunaDependency = (cityField.dataset?.selectorLevel || 0) > 3;
    if (isComunaDependency) bylForms.associateSelects(comunasSelectSelector, citySelector);
    else bylForms.associateSelects(statesSelectSelector, citySelector);
  },
  associateComunaSelectToStateSelect() {
    bylForms.associateSelects(statesSelectSelector, comunasSelectSelector);
  },
  associateCountrySelectToStateSelect() {
    bylForms.associateSelects(countrySelectSelector, statesSelectSelector);
  },
  removeAddress() {
    const removeAddressButtonElements = document.querySelectorAll('.checkout-main__remove-address');
    forEachElement(removeAddressButtonElements, (buttonElement) => {
      // eslint-disable-next-line listeners/no-missing-remove-event-listener, listeners/no-inline-function-event-listener
      buttonElement.addEventListener('click', (event) => {
        const el = event.target;
        const addressId = el.dataset.id;
        const { isDefault } = el.dataset;
        const deletedWasSelected = el.closest('.address-option').querySelector('input').checked;
        const { default: getFrontConfig } = require('../common/getFrontConfig');
        const url = getFrontConfig().urls.deleteAddressUrl;

        const params = {
          addressId,
          isDefault,
        };

        const fetchurl = `${url}?${new URLSearchParams(params).toString()}`;
        bylFormHelpers.removeCheckoutError();

        fetch(fetchurl, {
          method: 'GET',
          dataType: 'json',
        })
          .then((response) => response.json())
          .then((data) => {
            if (data.error) {
              bylFormHelpers.addCheckoutError(data.errorMessage);
            } else {
              const deletedShippingAddress = document.querySelector(`input[id*="shippingAddress-${addressId}"]`).closest('.address-option');
              const deteledBillingAddress = document.querySelector(`input[id*="billingAddress-${addressId}"]`).closest('.address-option');
              deletedShippingAddress.remove();
              deteledBillingAddress.remove();

              const addressSelector = document.querySelector('.single-shipping .addressSelector');

              if (data.emptyAddressBook) {
                window.location.reload();
              } else if (deletedWasSelected) {
                addressSelector.querySelectorAll('.address-option input')[0].checked = true;
                // Trigger saved address change to validate it on load
                const changeEvent = new Event('change');
                addressSelector.dispatchEvent(changeEvent);
              }
            }
          })
          .catch(() => {
            bylFormHelpers.addCheckoutError();
          });
      });
    });
  },
};
